import doctor from '../assets/doctor.svg'
import chat from '../assets/chat.svg'
import response from '../assets/response.svg'
import secure from '../assets/secure.svg'

export const content = [
  {
    heading: 'Facilitates smooth, real-time doctor-user',
    text: ' communication for efficient consultations.',
    image: doctor
  },
  {
    heading: 'Supports video, voice, and text consultations,',
    text: ' offering flexible options for users.',
    image: chat
  },
  {
    heading: 'Allows doctors to provide prompt responses to',
    text: ' medical queries, enhancing care delivery.',
    image: response
  },
  {
    heading: 'Maintains patient confidentiality through a secure,',
    text: ' HIPAA-compliant platform.',
    image: secure
  }
]

export const keyPoints = [
  {
    heading: '1,000+',
    text: 'registered doctors'
  },
  {
    heading: '1,000+',
    text: 'consultations conducted'
  },
  {
    heading: '50+',
    text: 'specialties covered'
  }
]



// WEBPACK FOOTER //
// ./src/data/loginContent.js